export default __webpack_public_path__ + "static/media/storydots-logo.f68c1eb0.svg";